import createIcon from '@/lib/create-icon'

const CoinsIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
    <path
      d='M7.91667 6.66667C7.52858 6.66667 7.15002 6.70748 6.78505 6.78505C7.30542 4.33672 9.47988 2.5 12.0833 2.5C15.0749 2.5 17.5 4.92512 17.5 7.91667C17.5 10.5201 15.6633 12.6946 13.2149 13.2149C13.2925 12.85 13.3333 12.4714 13.3333 12.0833M7.91667 6.66667C10.9082 6.66667 13.3333 9.09179 13.3333 12.0833M7.91667 6.66667C4.92512 6.66667 2.5 9.09179 2.5 12.0833C2.5 15.0749 4.92512 17.5 7.91667 17.5C10.9082 17.5 13.3333 15.0749 13.3333 12.0833M7.91667 9.89583V9.16667M7.91667 14.2708V15M6.47095 13.75C6.80716 14.2308 7.34093 14.2733 7.91762 14.2733C8.69427 14.2733 9.58333 14.1126 9.58333 13.25C9.58333 12.78 9.21762 12.3708 8.69762 12.2558L7.13571 11.9125C6.61667 11.7983 6.25 11.3883 6.25 10.9183C6.25 10.0558 7.13906 9.895 7.91571 9.895C8.49125 9.895 9.02519 9.93628 9.36143 10.4158'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'CoinsIcon'
)

export default CoinsIcon
